import { AppModule } from 'app/module';
import Template from './template.hbs';
import './styles.scss';

export class SwitchToJobSearchDisruptor extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    domBindings() {
        return {
            link: '.m-switchToJobSearchDisruptor__link',
        };
    }

    removeSeoView() {
        this.dom.link.classList.remove('m-switchToJobSearchDisruptor__link--seo');
    }
}
